import React from "react";
import { Card, CardContent, Divider, CircularProgress } from "../../../tailwindcomponents";
import { Groups as GroupsIcon } from '../../../components/icons';
import {Team} from '../../../types/maintenanceTeams';
import { User } from "../../../types/user";
import { ProfileImg } from "../../../components";

const TeamCard: React.FC<{ team: Team, employees: User[] }> = ({ team, employees }) => {
  return (
    <Card
      elevation={2}
      className="rounded-lg h-full flex flex-col"
    >
      <div className="bg-primary text-[color:var(--ds-accent-fg)] p-3 rounded-t-lg">
        <div className="font-semibold text-xs">
          {team.TeamName}
        </div>
        <div className="flex flex-row items-center gap-2 mt-1">
            <ProfileImg
                imgKey={team.TeamLeaderId}
                userName={employees.find(emp => emp.Id === team.TeamLeaderId)?.userName?.split('@')[0]}
              />
          <span className="text-[0.85rem] font-medium">
            {employees.find(emp => emp.Id === team.TeamLeaderId)?.employee_name || "Unknown"}
          </span>
        </div>
      </div>

      <CardContent className="flex-grow p-3">
        <div className="flex flex-row items-center gap-1 mb-2">
          <GroupsIcon fontSize="1rem" color="rgba(0,0,0,0.6)" />
          <span className="text-muted text-xs">
            {team.TeamMembers?.length || 0} Members
          </span>
        </div>

        <Divider className="mb-2" />

        <div className="flex flex-col gap-1">
          {team.TeamMembers?.map((member, idx) => (
            <div
              key={member.TeamMemberId}
              className="flex flex-row items-center gap-2"
            >
              <ProfileImg
                imgKey={member.TeamMemberId}
                userName={employees.find(emp => emp.Id === member.TeamMemberId)?.userName?.split('@')[0]}
              />
              <span className="text-[0.8rem]">
                {employees.find(emp => emp.Id === member.TeamMemberId)?.employee_name || "Unknown"}
              </span>
            </div>
          )) || (
            <span className="text-muted text-xs">
              No team members
            </span>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

const TeamOverview: React.FC<{ teams: Team[], employees: User[], loading?: boolean }> = ({ teams, employees, loading = false }) => {
  
  if (loading) {
    return (
      <div className="flex justify-center items-center p-4 min-h-[120px]">
        <CircularProgress size={32} />
      </div>
    );
  }

  if (!teams || teams.length === 0) {
    return (
      <div className="p-4">
        <div className="text-muted text-[0.85rem]">
          No teams available.
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {teams.map((team) => (
          <div key={team.Id}>
            <TeamCard team={team} employees={employees} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamOverview;
